import { Navigate } from "react-router-dom";
import { obtenerRol, rutaInicio } from "../utils/sesion";

// canActivate: hay sesión. roles (opcional): roles que pueden ver la ruta;
// si el rol no está permitido se redirige a la pantalla de inicio de su rol.
const PrivateRoute = (props) => {
  const { canActivate, component, roles } = props;

  if (!canActivate) {
    window.location.href = "/";
    return null;
  }

  const rol = obtenerRol();
  if (roles && !roles.includes(rol)) {
    return <Navigate to={rutaInicio(rol)} replace />;
  }

  return component;
};

export default PrivateRoute;
